import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import theme from './theme/theme';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Welcome from './pages/Welcome';
import Dashboard from './pages/Dashboard';
import Orders from './pages/Orders';
import Alerts from './pages/Alerts';
import Catalogs from './pages/Catalogs';
import Users from './pages/Users';
import Credentials from './pages/Credentials';
import Performance from './pages/Performance';
import Subscriptions from './pages/Subscriptions';
import PlaceOrder from './pages/PlaceOrder';
import MarketIntelligence from './pages/MarketIntelligence';
import './App.css';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <Switch>
            {/* Public route */}
            <Route exact path="/login" component={Login} />

            {/* Protected routes */}
            <ProtectedRoute exact path="/" component={Welcome} />
            <ProtectedRoute path="/dashboard" component={Dashboard} />
            <ProtectedRoute path="/orders" component={Orders} />
            <ProtectedRoute path="/alerts" component={Alerts} />
            <ProtectedRoute path="/catalogs" component={Catalogs} />
            <ProtectedRoute path="/users" component={Users} adminOnly />
            <ProtectedRoute path="/credentials" component={Credentials} />
            <ProtectedRoute path="/performance" component={Performance} />
            <ProtectedRoute path="/subscriptions" component={Subscriptions} adminOnly />
            <ProtectedRoute path="/place-order" component={PlaceOrder} />
            <ProtectedRoute path="/market-intelligence" component={MarketIntelligence} adminOnly />
          </Switch>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
